import React from "react";
import img1 from "../../../images/LandingPageImage/card_e_commerce_.webp";
import img2 from "../../../images/LandingPageImage/card_education_.webp";
import img3 from "../../../images/LandingPageImage/card_healthcare_.webp";
import img4 from "../../../images/LandingPageImage/card_hospitality_restro_.webp";
import img5 from "../../../images/LandingPageImage/card_small_business_.webp";
import img6 from "../../../images/LandingPageImage/card_logistics.webp";
import img7 from "../../../images/LandingPageImage/Chat2.png";
import img8 from "../../../images/LandingPageImage/Chat1.png";
import img9 from "../../../images/LandingPageImage/Chat6.png";
import img10 from "../../../images/LandingPageImage/Chat3.png";
import img11 from "../../../images/LandingPageImage/Chat4.png";
import img12 from "../../../images/LandingPageImage/Chat5.png";

const items = [
  {
    id: 1,
    title: "Hospitality & Restaurants",
    image: img4,
    iconColor: "#5899DF",
    iconImage: img7,
  },
  {
    id: 2,
    title: "Logistics & Delivery",
    image: img6,
    iconColor: "#FF6801",
    iconImage: img8,
  },
  {
    id: 3,
    title: "Education & Coaching",
    image: img2,
    iconColor: "#25B894",
    iconImage: img9,
  },
  {
    id: 4,
    title: "E-Commerce",
    image: img1,
    iconColor: "#764ba2",
    iconImage: img10,
  },
  {
    id: 5,
    title: "Small Business",
    image: img5,
    iconColor: "#B24EFF",
    iconImage: img11,
  },
  {
    id: 6,
    title: "Healthcare & Wellness",
    image: img3,
    iconColor: "#4E60FF",
    iconImage: img12,
  },
];

const ForthSection = () => {
  return (
    <>
      <style>{`
        :root {
          --container-max: 1200px;
          --card-radius: 18px;
          --accent-color: #2F2CD8;
          --section-side-pad: 2rem;
        }

        /* ===== SECTION ===== */
        .ws-section {
          padding: 4rem var(--section-side-pad);
          display: flex;
          justify-content: center;
          background: transparent;
        }

        .ws-container {
          max-width: var(--container-max);
          width: 100%;
          margin: 0 auto;
        }

        .ws-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .ws-title-main {
          font-size: 2.1rem;
          max-width: 550px;
          margin: 0 auto;
          font-weight: 700;
          color: var(--accent-color);
        }

        .ws-header-text {
          max-width: 700px;
          margin: 0.75rem auto 0;
          font-size: 1.05rem;
          color: #475569;
        }

        /* ===== GRID ===== */
        .ws-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.5rem;
        }

        .ws-item {
          width: 100%;
        }

        /* ===== CARD ===== */
        .ws-card {
          width: 100%;
          aspect-ratio: 13 / 10;
          border-radius: var(--card-radius);
          overflow: hidden;
          position: relative;
          cursor: pointer;
          transition: transform 0.28s ease, box-shadow 0.28s ease;
          background-color: transparent;
          background-size: 100%;              
          background-position: center right ;
          background-repeat: no-repeat;
        }

        .ws-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 40px rgba(16,24,40,0.12);
        }

        .ws-card::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(0,0,0,0.28),
            rgba(0,0,0,0.08)
          );
          z-index: 1;
        }

        /* ===== TITLE OVERLAY ===== */
        .ws-title-overlay { 
        position: absolute; 
        top: 20px; left: 20px;
         background: #ffffff;
          padding: 5px 10px; 
          border-radius: 35px;
           z-index: 4;
            display: inline-flex;
             align-items: center; 
             gap: 12px; 
             outline: 12px solid rgba(255,255,255,0.6);
              outline-offset: 0px; box-shadow: 0 0 0 2px #ffffff, 0 6px 18px rgba(16,24,40,0.08); }

        .ws-chat-icon {
          width: 28px;
          height: 28px;
          object-fit: contain;
        }

        .ws-overlay-text {
          font-size: 0.85rem;
          font-weight: 500;
          margin: 0;
          white-space: nowrap;
        }

        /* ===== RESPONSIVE ===== */
        @media (max-width: 992px) {
          .ws-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 640px) {
          .ws-grid {
            grid-template-columns: 1fr;
          }

          .ws-card {
            aspect-ratio: 15 / 12;
          }
        }
      `}</style>

      <section className="ws-section">
        <div className="ws-container">
          <div className="ws-header">
            <h2 className="ws-title-main">
              Simple WhatsApp Messaging Automation for All Businesses
            </h2>
            <p className="ws-header-text">
              Dhroom helps you connect with customers quickly and easily. Send messages to many people at once, personalize your chats, engage leads, and increase sales—all while saving time with easy-to-use automation.
            </p>
          </div>

          <div className="ws-grid">
            {items.map((item) => (
              <article key={item.id} className="ws-item">
                <div
                  className="ws-card"
                  style={{ backgroundImage: `url(${item.image})` }}
                >
                  <div className="ws-title-overlay">
                    <img src={item.iconImage} alt="" className="ws-chat-icon" />
                    <p
                      className="ws-overlay-text"
                      style={{ color: item.iconColor }}
                    >
                      {item.title}
                    </p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForthSection;
